<template>
  <div class="sb_limit-input">
    <!-- eslint-disable-next-line -->
    <v-popover
      v-if="attrs['show-warning'] && outOfBounds"
      trigger="click"
      class="sb_limit-input_popover"
    >
      <button class="sb_limit-input_exclamation tooltip-target">
        <SvgIcon :icon-id="'icon_ui_exclamation'" />
      </button>

      <template slot="popover">
        <button
          v-close-popover
          class="tooltip-btn-close"
        >
          <SvgIcon :icon-id="'icon_ui_close'" />
        </button>
        <p>Your value is out of bounds. <br> {{ attrs.description }}</p>


        <button
          v-close-popover
          tag="button"
          class="sb_button v_has-icon-right v_icon-faded
          v_ghost_brand-primary-lighter v_expand-on-small"
          @click="$emit('input', Number(attrs.min))"
        >
          <ButtonObject icon="icon_ui_caret-right">
            set min ({{ attrs.min }})
          </ButtonObject>
        </button>

        <button
          v-close-popover
          tag="button"
          class="sb_button v_has-icon-right v_icon-faded
          v_ghost_brand-primary-lighter v_expand-on-small"
          @click="$emit('input', Number(attrs.max))"
        >
          <ButtonObject icon="icon_ui_caret-right">
            set max ({{ attrs.max }})
          </ButtonObject>
        </button>
      </template>
    <!-- eslint-disable-next-line -->
    </v-popover>


    <input
      :class="{'s_was-limited': wasLimited, 's_out-of-bounds': outOfBounds}"
      :value="value"
      v-bind="attrs"
      data-lpignore="true"
      :style="{
        height: compact ? '20px' : '30px',
        padding: compact ? '0 0.75rem 0.5rem 0.75rem' : '0 0.75rem 0.75rem 0.75rem'
      }"
      @focusout="input"
      @keyup="input"
      @change="input"
      @focus="wasLimited = false"
      v-on="listeners"
    >
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [
        String,
        Number
      ],
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wasLimited: false
    };
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { ...attrs } = this.$attrs;
      return attrs;
    },
    outOfBounds() {
      const val = !(Number(this.value) >= Number(this.attrs.min)
        && Number(this.value) <= Number(this.attrs.max));
      this.$emit('update:out-of-bounds', val);
      return val;
    }
  },
  mounted() {},
  methods: {
    input(event) {
      this.$emit('input', event.target.value === '' ? 0 : event.target.value);
    }
  }
};
</script>

<style lang="scss">

.sb_limit-input {
  position: relative;

  &_popover {
    position: absolute;
    left: -2rem;
    top: 0;
  }
  &_exclamation {
    position: absolute;
    top: 0;
    transform: scale(1.2);
    color: $brand-red;
  }
  &_info {
    position: absolute;
    top: 0;
    transform: scale(1.2);
    color: $brand-primary-lighter;

  }

  input.s_out-of-bounds {
    border-color: $brand-error;
    background: rgba( $brand-error, .1);
  }
  input.s_was-limited {
    animation-name: input-limited;
    animation-duration: 1.5s;
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
  }

}


@keyframes input-limited {
  0% {
    border-color: rgba($brand-primary-lighter, 0.5);
    background: transparent;
  }
  15% {
    border-color: orange;
    background: rgba(orange, .1);
  }
  100% {
    border-color: rgba($brand-primary-lighter, 0.5);
    background: transparent;
  }
}

</style>
